/* Lineage / Paul Saladino Lander — interactivity bundle.
 *
 * Drives the hero gallery, reviews ticker, ambassadors marquee, sticky promo
 * bar, plan radio, flavor tiles (which swap copy + nutrition facts), tabs, and
 * gallery thumbs. Hooks via element IDs and dataset attributes that match the
 * Liquid markup in sections/lander-*.liquid.
 */
(function () {
  /* Reviews ticker (two opposing rows, duplicate children for seamless loop) */
  ['rc-row-1', 'rc-row-2'].forEach((id) => {
    const row = document.getElementById(id);
    if (!row) return;
    const originals = Array.from(row.children);
    originals.forEach((c) => row.appendChild(c.cloneNode(true)));
  });

  /* Ambassadors auto-marquee */
  (function () {
    const row = document.getElementById('ambRow');
    if (!row) return;
    const originals = Array.from(row.children);
    originals.forEach((c) => row.appendChild(c.cloneNode(true)));
  })();

  /* Sticky promo bar: hidden before scroll, visible after 400px */
  (function () {
    const el = document.getElementById('lpSticky');
    if (!el) return;
    const SHOW_AFTER = 400;
    const update = () => {
      if (window.scrollY > SHOW_AFTER) el.classList.add('is-visible');
      else el.classList.remove('is-visible');
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  })();

  /* Hero gallery — slides cycling every 5s with dot + arrow controls */
  (function () {
    const container = document.getElementById('heroGallery');
    if (!container) return;
    const dots = document.querySelectorAll('.lp-hero__gallery-dot');
    const arrows = document.querySelectorAll('.lp-hero__gallery-arrow');
    const n = container.children.length || 6;
    let idx = 0;
    let timer;

    const go = (i) => {
      idx = (i + n) % n;
      container.style.transform = 'translateX(' + (-idx * (100 / n)) + '%)';
      dots.forEach((d, di) => d.classList.toggle('active', di === idx));
    };

    const start = () => {
      timer = setInterval(() => go(idx + 1), 5000);
    };

    dots.forEach((d, di) =>
      d.addEventListener('click', () => {
        clearInterval(timer);
        go(di);
        start();
      })
    );
    arrows.forEach((a) =>
      a.addEventListener('click', () => {
        clearInterval(timer);
        go(idx + parseInt(a.dataset.dir, 10));
        start();
      })
    );
    start();
  })();

  /* Plan toggle (Subscribe & Save vs One-Time) — drives the Skio selling_plan input.
     Subscribe: enable #LanderSellingPlan with the configured plan ID.
     One-Time: disable the input so it isn't submitted (no selling_plan = one-time). */
  (function () {
    const planInput = document.getElementById('LanderSellingPlan');
    const cfg = window.LANDER_CONFIG || {};
    const planId = cfg.sellingPlanId || (planInput ? planInput.value : '');

    function setPlan(kind) {
      if (!planInput) return;
      if (kind === 'once') {
        planInput.disabled = true;
        planInput.value = '';
      } else {
        planInput.disabled = false;
        planInput.value = planId;
      }
    }

    document.querySelectorAll('.pdp__plan').forEach((p) => {
      p.addEventListener('click', () => {
        // Skip disabled subscribe plan (product not on Skio yet)
        if (p.classList.contains('pdp__plan--unavailable') || p.getAttribute('aria-disabled') === 'true') return;
        document.querySelectorAll('.pdp__plan').forEach((x) => x.classList.remove('active'));
        p.classList.add('active');
        setPlan(p.dataset.plan);
      });
    });
    const activePlan = document.querySelector('.pdp__plan.active');
    setPlan(activePlan ? activePlan.dataset.plan : 'sub');
  })();

  /* Bind buy-box gallery thumbnails (re-callable after flavor swaps rebuild them). */
  function bindThumbs() {
    document.querySelectorAll('.lp-gallery__thumb').forEach((t) => {
      if (t.dataset.bound) return;
      t.dataset.bound = '1';
      t.addEventListener('click', () => {
        document.querySelectorAll('.lp-gallery__thumb').forEach((x) => x.classList.remove('active'));
        t.classList.add('active');
        const img = document.getElementById('galleryMainImg');
        if (img && t.dataset.img) img.src = t.dataset.img;
      });
    });
  }

  /* Flavor tiles → swap ingredients copy + Nutrition Facts panel.
     FLAVOR_DATA populated from Liquid via window.LANDER_FLAVOR_DATA so the
     offer section's settings drive copy and per-flavor nutrition values. */
  const FLAVOR_DATA = window.LANDER_FLAVOR_DATA || {};

  function applyFlavor(flavor) {
    // Collection-driven data: `flavor` is the product handle (e.g. 'lineage-bar-chocolate').
    const d = FLAVOR_DATA[flavor];
    if (!d) return;

    const set = (id, v) => {
      const el = document.getElementById(id);
      if (el && v != null) el.textContent = v;
    };

    // Ingredients tab: header pill = flavor name, label image = full nutrition label
    set('ing-pill', d.flavorName);
    const labelImg = document.getElementById('nfp-label-img');
    if (labelImg) {
      if (d.labelImage) {
        labelImg.src = d.labelImage;
        labelImg.hidden = false;
        labelImg.alt = 'Nutrition Facts & Ingredients — ' + (d.flavorName || '');
      } else {
        labelImg.src = '';
        labelImg.hidden = true;
      }
    }

    // Sold-out state on the buy button. Server sets the initial state; JS re-syncs on flavor swap.
    const cta = document.querySelector('.pdp__cta');
    if (cta) {
      const activeLabel = cta.getAttribute('data-active-label') || cta.textContent;
      const soldOutLabel = cta.getAttribute('data-sold-out-label') || 'SOLD OUT';
      if (d.available === false) {
        cta.disabled = true;
        cta.setAttribute('aria-disabled', 'true');
        cta.classList.add('pdp__cta--sold-out');
        cta.textContent = soldOutLabel;
      } else {
        cta.disabled = false;
        cta.removeAttribute('aria-disabled');
        cta.classList.remove('pdp__cta--sold-out');
        cta.textContent = activeLabel;
      }
    }

    // Subscribable state on the plan cards. If the product isn't on any Skio
    // selling plan group, disable the Subscribe card and force-select One-Time.
    const subCard = document.querySelector('.pdp__plan[data-plan="sub"]');
    const onceCard = document.querySelector('.pdp__plan[data-plan="once"]');
    const planInput = document.getElementById('LanderSellingPlan');
    const cfg = window.LANDER_CONFIG || {};
    if (subCard && onceCard) {
      if (d.subscribable === false) {
        subCard.classList.add('pdp__plan--unavailable');
        subCard.classList.remove('active');
        subCard.setAttribute('aria-disabled', 'true');
        onceCard.classList.add('active');
        if (planInput) { planInput.disabled = true; planInput.value = ''; }
      } else {
        subCard.classList.remove('pdp__plan--unavailable');
        subCard.removeAttribute('aria-disabled');
        // Restore sub as default active only if user hadn't explicitly picked one-time on this session.
        // Simplest correct behavior: re-activate sub when switching to a subscribable flavor.
        subCard.classList.add('active');
        onceCard.classList.remove('active');
        if (planInput) { planInput.disabled = false; planInput.value = cfg.sellingPlanId || planInput.value; }
      }
    }

    // Prices — stacked model. Sub first-order = base × (1-sub_pct) × (1-once_pct).
    // One-time price includes the coupon (matches the base's compareAt strike-through).
    set('plan-sub-price', d.subPrice);
    set('plan-sub-was', d.subWas);
    if (d.subPerBar) set('plan-sub-perbar', d.subPerBar + ' / bar');
    set('plan-once-price', d.oncePrice);
    set('plan-once-was', d.onceWas);
    if (d.oncePerBar) set('plan-once-perbar', d.oncePerBar + ' / bar');

    // Gallery swap — replace main image + thumbs with this product's media.
    if (Array.isArray(d.gallery) && d.gallery.length) {
      const mainImg = document.getElementById('galleryMainImg');
      if (mainImg) mainImg.src = d.gallery[0];
      const thumbs = document.getElementById('galleryThumbs');
      if (thumbs) {
        thumbs.innerHTML = d.gallery
          .map(
            (url, i) =>
              '<button type="button" class="lp-gallery__thumb' +
              (i === 0 ? ' active' : '') +
              '" data-img="' + url + '" aria-label="Show product image ' + (i + 1) + '">' +
              '<img src="' + url + '" alt="" loading="lazy" style="width:100%;height:100%;object-fit:cover;display:block;"></button>'
          )
          .join('');
        bindThumbs();
      }
    }
  }

  /* Flavor tile click:
     1. Visual active state.
     2. Update the hidden #LanderVariantId so the cart form posts the right variant.
     3. Swap ingredients/NFP copy via applyFlavor().
     The variant ID for each flavor is rendered server-side into the tile's
     data-variant-id attribute by lander-page.liquid. */
  function selectFlavor(tile) {
    document.querySelectorAll('.pdp__flavor-tile').forEach((x) => {
      x.classList.remove('active');
      x.setAttribute('aria-checked', 'false');
    });
    tile.classList.add('active');
    tile.setAttribute('aria-checked', 'true');

    const vid = tile.dataset.variantId;
    const vidInput = document.getElementById('LanderVariantId');
    if (vid && vidInput) vidInput.value = vid;

    applyFlavor(tile.dataset.flavor);
  }

  document.querySelectorAll('.pdp__flavor-tile').forEach((t) => {
    t.addEventListener('click', () => selectFlavor(t));
    t.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        selectFlavor(t);
      }
    });
  });
  const initialTile = document.querySelector('.pdp__flavor-tile.active');
  if (initialTile) applyFlavor(initialTile.dataset.flavor);

  /* AJAX add-to-cart + open the host theme's cart drawer.
     The buy form is rendered by Shopify's {% form 'product' %} so we intercept
     submit, POST to /cart/add.js (Shopify Ajax API), then try common
     drawer-open patterns. If nothing matches, fall back to /cart. */
  (function () {
    const form = document.querySelector('form[action$="/cart/add"], form[data-lander-cart-form]');
    if (!form) return;

    /* Add-to-cart flow — mirrors the theme's own lander pattern
       (see compiled_assets/scripts.js: fetch /cart/add.js with JSON body,
       apply the DRPAUL discount code as a background /discount fetch, then
       redirect to /cart). No drawer manipulation — /cart is the reliable
       destination on this store's live theme. */
    const discountCode = form.getAttribute('data-discount-code') ||
      (form.querySelector('input[name="properties[_discount_code]"]') || {}).value ||
      '';
    const cartUrl = form.getAttribute('data-cart-url') || '/cart';
    const discountUrl = discountCode
      ? '/discount/' + encodeURIComponent(discountCode) + '?redirect=/cart.js'
      : null;

    function applyDiscount() {
      if (!discountUrl) return;
      try {
        fetch(discountUrl, { credentials: 'same-origin', cache: 'no-store' });
      } catch (e) {}
    }
    // Pre-apply on page load so the code is on the cart before the first add.
    applyDiscount();
    document.addEventListener('lineage:cart-added', applyDiscount);

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = form.querySelector('.pdp__cta');
      // Guard: if the current flavor is sold out, don't attempt an add.
      if (btn && (btn.disabled || btn.classList.contains('pdp__cta--sold-out'))) return;
      const originalLabel = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

      // Build a JSON item payload — matches the theme's proven /cart/add.js shape.
      const variantEl = document.getElementById('LanderVariantId');
      const planEl = document.getElementById('LanderSellingPlan');
      const rawVid = variantEl ? variantEl.value : '';
      const vid = parseInt(rawVid, 10) || rawVid;
      const item = { id: vid, quantity: 1 };
      // Only include selling_plan when the active flavor is actually subscribable.
      // Prevents 422s when a product isn't on Skio (e.g. a new flavor mid-launch).
      const activeTile = document.querySelector('.pdp__flavor-tile.active');
      const activeHandle = activeTile ? activeTile.dataset.flavor : null;
      const activeFlavorData = activeHandle ? (FLAVOR_DATA[activeHandle] || {}) : {};
      const isSubscribable = activeFlavorData.subscribable !== false;
      const subCardActive = !!document.querySelector('.pdp__plan[data-plan="sub"].active');
      if (isSubscribable && subCardActive && planEl && !planEl.disabled && planEl.value) {
        item.selling_plan = parseInt(planEl.value, 10) || planEl.value;
      }
      if (discountCode) {
        item.properties = Object.assign(item.properties || {}, { _discount_code: discountCode });
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] }),
        credentials: 'same-origin',
      })
        .then((r) => {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(() => {
          // Notify listeners (theme uses this name in its own landers).
          document.dispatchEvent(new CustomEvent('lineage:cart-added', { detail: item, bubbles: true }));

          // UpCart is set to openOnAddToCart=true on this store — it intercepts
          // /cart/add.js and opens its drawer automatically. AfterSell (where UpCart
          // is absent) is opened directly. Give either up to 1.5s to render, then
          // fall back to a full /cart navigation if it didn't open.
          const aftersell = window.aftersell?.cart?.actions;
          if (typeof window.upcartOpenCart !== 'function' && aftersell && typeof aftersell.open === 'function') {
            Promise.resolve(aftersell.refresh?.()).catch(() => {}).then(() => aftersell.open());
          }
          const start = Date.now();
          const poll = setInterval(() => {
            const drawerOpen =
              document.body.classList.contains('upcartPopupShow') ||
              document.body.classList.contains('cart-drawer-open') ||
              document.body.classList.contains('js-show-ajax-cart') ||
              !!document.querySelector('[class*="upcart"][class*="Popup"]:not([style*="display: none"]):not([style*="display:none"])');
            if (drawerOpen) {
              clearInterval(poll);
              if (btn) { btn.disabled = false; btn.textContent = originalLabel; }
              return;
            }
            if (Date.now() - start > 1500) {
              clearInterval(poll);
              // UpCart didn't open — fall back to a full cart navigation so user still sees their item.
              window.location.href = cartUrl;
            }
          }, 100);
        })
        .catch(() => {
          // Fallback: let the browser do a native form submit so the item still lands.
          if (btn) { btn.disabled = false; btn.textContent = originalLabel; }
          try { form.submit(); } catch (e) { window.location.href = cartUrl; }
        });
    });
  })();

  /* How-To-Eat / Ingredients tabs */
  document.querySelectorAll('.pdp__tab-btn').forEach((b) => {
    b.addEventListener('click', () => {
      document.querySelectorAll('.pdp__tab-btn').forEach((x) => x.classList.remove('active'));
      document.querySelectorAll('.pdp__tab-panel').forEach((x) => x.classList.remove('active'));
      b.classList.add('active');
      const panel = document.querySelector('.pdp__tab-panel[data-tab="' + b.dataset.tab + '"]');
      if (panel) panel.classList.add('active');
    });
  });

  /* Buy-box gallery thumbs (initial bind; re-bound after flavor swaps) */
  bindThumbs();

  /* Ambassador video cards → 9:16 modal player (with audio + controls).
     Delegated so marquee-cloned cards also open the modal. */
  (function () {
    const modal = document.getElementById('vidModal');
    const modalVideo = document.getElementById('vidModalVideo');
    const closeBtn = document.getElementById('vidModalClose');
    if (!modal || !modalVideo) return;

    function openModal(src) {
      if (!src) return;
      modalVideo.src = src.split('#')[0]; // strip #t=N poster hash so it plays from 0
      try { modalVideo.currentTime = 0; } catch (e) {}
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      const p = modalVideo.play();
      if (p && p.catch) p.catch(() => {});
    }
    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      modalVideo.pause();
      modalVideo.removeAttribute('src');
      modalVideo.load();
      document.body.style.overflow = '';
    }

    document.addEventListener('click', (e) => {
      const card = e.target.closest && e.target.closest('.amb-card--video');
      if (!card) return;
      const v = card.querySelector('.amb-card__video');
      if (v) openModal(v.getAttribute('src') || v.src);
    });
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  })();
})();
